<div
  class="drop-zone"
  [class.dragover]="isDragging"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <span class="form-label fs-10 text-secondary" *ngIf="label">{{ label }}</span>
  <div class="p-3 mb-auto mt-auto">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <p class="mat-body-1">
        Arraste {{ multiple ? "seus arquivos" : "seu arquivo" }} aqui
      </p>
      <p class="mat-caption">ou</p>
      <button mat-raised-button color="primary" (click)="fileInput.click()">
        Selecionar {{ multiple ? "arquivos" : "arquivo" }}
      </button>
      <input
        #fileInput
        type="file"
        hidden
        [multiple]="multiple"
        (change)="onFileSelected($event)"
      />
    </div>
  </div>
</div>
<hr *ngIf="pendingFiles.length > 0 || controlArray.value.length > 0" />
<dynamic-list *ngIf="controlArray.value.length > 0">
  <dynamic-list-item *ngFor="let anexoGroup of controlArray.controls">
    <div class="d-flex gap-3 justify-content-between align-items-center">
      <div class="d-flex flex-column">
        <span>{{ anexoGroup.value.nomeArquivo }}</span>
        <span class="fs-10 text-secondary">{{
          helper.formatBytes(anexoGroup.value.tamanho)
        }}</span>
      </div>
      <div>
        <button
          mat-icon-button
          (click)="removeAnexo(anexoGroup.value.id, anexoGroup.value.token)"
        >
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </div>
    <div class="row" *ngIf="!nomeFormDisabled || !dataFormDisabled || !tipoFormDisabled">
      <div class="col-6">
        <mat-form-field appearance="outline" class="anexo-info-input">
          <mat-label>Nome</mat-label>
          <input matInput [formControl]="anexoGroup.get('nome')" />
          <mat-error
            *ngIf="
              anexoGroup.get('nome').hasError('required') &&
              anexoGroup.get('nome').touched
            "
            >Campo Obrigatório</mat-error
          >
          <mat-error
            *ngIf="
              anexoGroup.get('nome').hasError('maxlength') &&
              anexoGroup.get('nome').touched
            "
            >{{ anexoGroup.get("nome").getError("maxlength").actualLength }}
            caracteres utilizados. O máximo de caracteres permitidos é
            {{
              anexoGroup.get("nome").getError("maxlength").requiredLength
            }}.</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field
          appearance="outline"
          class="anexo-info-input"
          *ngIf="!dataFormDisabled"
        >
          <mat-label> Data do documento</mat-label>
          <input
            matInput
            [matDatepicker]="dataDocumento"
            [formControl]="anexoGroup.get('dataDocumento')"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="dataDocumento"
          ></mat-datepicker-toggle>
          <mat-datepicker #dataDocumento></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="row mt-2" *ngIf="!tipoFormDisabled">
      <div class="col-6">
        <app-anexo-tipo [formControl]="anexoGroup.get('tipoAnexo')"></app-anexo-tipo>
      </div>
    </div>
  </dynamic-list-item>
</dynamic-list>
<dynamic-list *ngIf="pendingFiles.length > 0">
  <dynamic-list-item *ngFor="let file of pendingFiles">
    <div
      class="d-flex gap-3 align-items-center justify-content-between position-relative"
    >
      <div class="d-flex flex-column">
        <span>{{ file.file.name }}</span>
        <span class="fs-10 text-secondary">{{
          helper.formatBytes(file.file.size)
        }}</span>
      </div>
      <button mat-icon-button (click)="cancelUpload(file)">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
    <app-input-loading
      [legacyInput]="true"
      [relativePosition]="true"
      [isLoading]="file.loading"
    ></app-input-loading>
  </dynamic-list-item>
</dynamic-list>
